// Generates a QR code based on a url

import QRCode from 'qrcode';

interface QROptions {
  margin?: number;
  errorCorrectionLevel?: 'L' | 'M' | 'Q' | 'H';
  width?: number;
  scale?: number;
  color?: {
    dark?: string;
    light?: string;
  };
}

const DEFAULT_QR_OPTIONS: QROptions = {
  errorCorrectionLevel: 'H',
  margin: 1,
  color: {
    dark: '#000000',
    light: '#ffffff',
  },
};

const getMergedQrOptions = (options: QROptions = {}): QROptions => ({
  ...DEFAULT_QR_OPTIONS,
  ...options,
  color: {
    ...DEFAULT_QR_OPTIONS.color,
    ...options.color,
  },
});

export async function generateQrCode(
  url: string,
  options: QROptions = {}
): Promise<string> {
  const mergedOptions = getMergedQrOptions(options);

  return QRCode.toDataURL(url, {
    ...mergedOptions,
  });
}
